import AuditLogUseCase from "./AuditLogUseCase";

export function auditLogUseCase() {
  return new AuditLogUseCase();
}
